import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Hero = ({ onOpenConsultation }) => {
  const [activeTab, setActiveTab] = useState('analytics');

  const metrics = [
    { value: '10M+', label: 'API Calls Served', icon: 'fa-server', highlight: '#00D4FF' },
    { value: '99.99%', label: 'Uptime SLA', icon: 'fa-shield-alt', highlight: '#34D399' },
    { value: '₹50Cr+', label: 'FinTech Volume', icon: 'fa-bolt', highlight: '#A78BFA' },
    { value: '250+', label: 'Enterprise Clients', icon: 'fa-building', highlight: '#F472B6' },
  ];

  return (
    <section
      className="hero-section-container"
      style={{
        position: 'relative',
        paddingTop: '76px',
        paddingBottom: '50px',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        background: '#060816',
        transform: 'translateZ(0)',
        willChange: 'transform',
      }}
    >
      {/* Animated Square Grid Background Layer */}
      <div
        className="bg-grid-pattern"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1,
          opacity: 0.85,
          pointerEvents: 'none',
          maskImage: 'radial-gradient(ellipse 80% 80% at 50% 50%, black 40%, transparent 100%)',
          WebkitMaskImage: 'radial-gradient(ellipse 80% 80% at 50% 50%, black 40%, transparent 100%)',
        }}
      />
      
      {/* Smooth Background Orbs */}
      <div
        className="smooth-glow-orb-1"
        style={{
          position: 'absolute',
          top: '10%',
          left: '5%',
          width: '450px',
          height: '450px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(108, 99, 255, 0.25) 0%, rgba(6, 8, 22, 0) 70%)',
          pointerEvents: 'none',
          transform: 'translateZ(0)',
          willChange: 'transform',
        }}
      />
      <div
        className="smooth-glow-orb-2"
        style={{
          position: 'absolute',
          top: '25%',
          right: '5%',
          width: '500px',
          height: '500px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(0, 212, 255, 0.2) 0%, rgba(6, 8, 22, 0) 70%)',
          pointerEvents: 'none',
          transform: 'translateZ(0)',
          willChange: 'transform',
        }}
      />

      <div className="ht-container" style={{ position: 'relative', zIndex: 10, width: '100%' }}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(12, 1fr)',
            gap: '32px',
            alignItems: 'center',
          }}
          className="hero-grid"
        >
          {/* LEFT COLUMN: Main Hero Text */}
          <div style={{ gridColumn: 'span 6' }} className="hero-left">
            
            {/* Prominent Brand Header Badge with Animated Border Beam */}
            <div className="running-border-badge logo-header-chip" style={{ display: 'inline-block', marginBottom: '20px' }}>
              <div
                className="running-border-badge-inner"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '6px 16px 6px 8px',
                  borderRadius: '14px',
                }}
              >
                <div
                  style={{
                    width: '42px',
                    height: '42px',
                    borderRadius: '12px',
                    background: '#FFFFFF',
                    border: '2px solid #D6A236',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2px',
                    boxShadow: '0 0 16px rgba(214, 162, 54, 0.4), 0 0 12px rgba(0, 212, 255, 0.4)',
                    flexShrink: 0,
                    overflow: 'hidden',
                  }}
                >
                  <img
                    src="/assets/images/hungry-logo.svg"
                    alt="Hungry Top Technologies Logo"
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      transform: 'scale(1.9)',
                    }}
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span style={{ color: '#FFFFFF', fontWeight: 900, fontSize: '1.05rem', letterSpacing: '-0.02em', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                      HUNGRY TOP
                    </span>
                    <span className="pulse-dot"></span>
                  </div>
                  <span style={{ color: '#00D4FF', fontWeight: 800, fontSize: '0.55rem', letterSpacing: '0.2em', textTransform: 'uppercase' }}>
                    TECHNOLOGIES
                  </span>
                </div>
              </div>
            </div>

            {/* Headline */}
            <h1
              style={{
                fontSize: 'clamp(1.8rem, 3.2vw, 2.7rem)',
                fontWeight: 900,
                color: '#FFFFFF',
                lineHeight: 1.18,
                marginBottom: '16px',
                letterSpacing: '-0.03em',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
              }}
            >
              Building AI-Powered <br className="desktop-br" />
              Software Products & <br className="desktop-br" />
              <span className="text-gradient-primary">Digital Solutions</span>
            </h1>

            {/* Description */}
            <p
              style={{
                fontSize: '0.98rem',
                color: '#A3A8B8',
                lineHeight: 1.6,
                marginBottom: '24px',
                maxWidth: '520px',
              }}
            >
              We build scalable enterprise software platforms, AI products, fintech solutions, and custom mobile/web platforms that accelerate digital transformation.
            </p>

            {/* CTA Buttons */}
            <div className="hero-cta-group" style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '28px' }}>
              <Link to="/services" className="btn-primary-gradient" style={{ padding: '9px 22px', fontSize: '0.85rem', minHeight: '40px', borderRadius: '30px' }}>
                <span>Explore Our Services</span>
                <i className="fas fa-arrow-right" style={{ fontSize: '0.75rem' }}></i>
              </Link>
              <Link to="/products" className="btn-secondary-glass" style={{ padding: '9px 20px', fontSize: '0.85rem', minHeight: '40px', borderRadius: '30px' }}>
                <i className="fas fa-layer-group" style={{ color: '#00D4FF', fontSize: '0.8rem' }}></i>
                <span>View SaaS Products</span>
              </Link>
            </div>

            {/* Key Metrics Grid - Clean Minimalist Text */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: '12px',
                paddingTop: '20px',
                borderTop: '1px solid rgba(255, 255, 255, 0.08)',
              }}
              className="hero-metrics-grid"
            >
              {metrics.map((item, idx) => (
                <div key={idx} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '2px', justifyContent: 'center' }}>
                    <i className={`fas ${item.icon}`} style={{ color: item.highlight, fontSize: '0.78rem' }}></i>
                    <span style={{ fontSize: '1.2rem', fontWeight: 800, color: '#FFFFFF', fontFamily: "'Plus Jakarta Sans', sans-serif", whiteSpace: 'nowrap' }}>
                      {item.value}
                    </span>
                  </div>
                  <span style={{ fontSize: '0.72rem', color: '#A3A8B8', fontWeight: 600, lineHeight: 1.3 }}>
                    {item.label}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT COLUMN: 3D Control Center Dashboard with Running Neon Border Beam */}
          <div style={{ gridColumn: 'span 6', position: 'relative' }} className="hero-right">
            
            {/* Top Floating AI Robot Badge (With Running Border Beam) */}
            <div
              className="smooth-float-badge-top running-border-badge"
              style={{
                position: 'absolute',
                top: '-32px',
                right: '16px',
                zIndex: 20,
                willChange: 'transform',
                transform: 'translateZ(0)',
              }}
            >
              <div className="running-border-badge-inner" style={{ padding: '8px 14px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                {/* Robot Avatar Image Circle */}
                <div
                  style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    border: '2px solid #00D4FF',
                    boxShadow: '0 0 12px rgba(0, 212, 255, 0.5)',
                    flexShrink: 0,
                    background: '#0B0F24',
                  }}
                >
                  <img
                    src="/images/ai-automation-expert.png"
                    alt="AI Core Robot"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </div>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <span style={{ fontSize: '0.62rem', color: '#00D4FF', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                      AI CORE ACTIVE
                    </span>
                    <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#34D399' }}></span>
                  </div>
                  <span style={{ fontSize: '0.82rem', fontWeight: 800, color: '#FFF', lineHeight: 1.1, display: 'block' }}>
                    99.98% Accuracy
                  </span>
                </div>
              </div>
            </div>

            {/* Bottom Floating PaperLoan Preview Badge */}
            <div
              className="smooth-float-badge-bottom running-border-badge"
              style={{
                position: 'absolute',
                bottom: '-20px',
                left: '-16px',
                zIndex: 20,
                willChange: 'transform',
                transform: 'translateZ(0)',
              }}
            >
              <div className="running-border-badge-inner" style={{ padding: '12px 18px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div
                  style={{
                    width: '38px',
                    height: '38px',
                    borderRadius: '12px',
                    background: 'linear-gradient(135deg, #6C63FF 0%, #8B5CF6 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#FFF',
                    flexShrink: 0,
                  }}
                >
                  <i className="fas fa-landmark" style={{ fontSize: '1rem' }}></i>
                </div>
                <div>
                  <span style={{ fontSize: '0.68rem', color: '#A78BFA', fontWeight: 800, textTransform: 'uppercase', display: 'block' }}>
                    PAPERLOAN FINTECH
                  </span>
                  <span style={{ fontSize: '0.88rem', fontWeight: 800, color: '#FFF' }}>
                    Instant Approval Engine
                  </span>
                </div>
              </div>
            </div>

            {/* MAIN 3D CONTROL CENTER DASHBOARD WITH RUNNING AI GLOWING BORDER BEAM */}
            <div
              className="running-border-beam-card dashboard-3d-card"
              style={{
                transform: 'perspective(1000px) rotateY(-4deg) rotateX(2deg) translateZ(0)',
                willChange: 'transform',
                transition: 'transform 0.5s ease',
              }}
            >
              <div className="running-border-beam-inner" style={{ padding: '28px' }}>
                {/* Dashboard Window Header */}
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '18px',
                    paddingBottom: '14px',
                    borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
                    flexWrap: 'wrap',
                    gap: '8px',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '0' }}>
                    <div style={{ display: 'flex', gap: '5px', flexShrink: 0 }}>
                      <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#FF5F56' }}></span>
                      <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#FFBD2E' }}></span>
                      <span style={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#27C93F' }}></span>
                    </div>
                    <span
                      style={{
                        fontSize: '0.82rem',
                        fontWeight: 700,
                        color: '#FFFFFF',
                        letterSpacing: '0.01em',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Control Center
                    </span>
                  </div>

                  {/* Dashboard Tabs */}
                  <div style={{ display: 'flex', background: 'rgba(255, 255, 255, 0.05)', borderRadius: '8px', padding: '2px', flexShrink: 0 }}>
                    {['analytics', 'ai', 'cloud'].map((tab) => (
                      <button
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        style={{
                          padding: '4px 10px',
                          borderRadius: '6px',
                          border: 'none',
                          background: activeTab === tab ? 'linear-gradient(135deg, #6C63FF 0%, #00D4FF 100%)' : 'transparent',
                          color: activeTab === tab ? '#FFFFFF' : '#A3A8B8',
                          fontSize: '0.72rem',
                          fontWeight: 700,
                          cursor: 'pointer',
                          textTransform: 'capitalize',
                          transition: 'all 0.25s ease',
                        }}
                      >
                        {tab}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Tab Content */}
                {activeTab === 'analytics' && (
                  <div className="fade-in-tab">
                    {/* Metric Cards */}
                    <div className="dashboard-inner-metrics-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginBottom: '16px' }}>
                      <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '10px 12px', borderRadius: '12px', border: '1px solid rgba(255, 255, 255, 0.06)' }}>
                        <span style={{ fontSize: '0.68rem', color: '#A3A8B8', display: 'block', fontWeight: 600, whiteSpace: 'nowrap' }}>Platform Users</span>
                        <span style={{ fontSize: '1.1rem', fontWeight: 800, color: '#FFFFFF' }}>24,532</span>
                        <span style={{ fontSize: '0.65rem', color: '#10B981', display: 'block', marginTop: '1px', fontWeight: 700 }}>↑ 14.8%</span>
                      </div>

                      <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '10px 12px', borderRadius: '12px', border: '1px solid rgba(255, 255, 255, 0.06)' }}>
                        <span style={{ fontSize: '0.68rem', color: '#A3A8B8', display: 'block', fontWeight: 600, whiteSpace: 'nowrap' }}>SaaS Revenue</span>
                        <span style={{ fontSize: '1.1rem', fontWeight: 800, color: '#00D4FF' }}>$148,920</span>
                        <span style={{ fontSize: '0.65rem', color: '#10B981', display: 'block', marginTop: '1px', fontWeight: 700 }}>↑ 22.4% ARR</span>
                      </div>

                      <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '10px 12px', borderRadius: '12px', border: '1px solid rgba(255, 255, 255, 0.06)' }}>
                        <span style={{ fontSize: '0.68rem', color: '#A3A8B8', display: 'block', fontWeight: 600, whiteSpace: 'nowrap' }}>PaperLoan</span>
                        <span style={{ fontSize: '1.1rem', fontWeight: 800, color: '#A78BFA' }}>₹15.4 Cr</span>
                        <span style={{ fontSize: '0.65rem', color: '#10B981', display: 'block', marginTop: '1px', fontWeight: 700 }}>↑ 31.2% YTD</span>
                      </div>
                    </div>

                    {/* LIVE ANIMATED SYSTEM PERFORMANCE TELEMETRY GRAPH */}
                    <div style={{ background: 'rgba(6, 8, 22, 0.75)', borderRadius: '14px', padding: '14px', border: '1px solid rgba(0, 212, 255, 0.2)', position: 'relative' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <span style={{ fontSize: '0.78rem', fontWeight: 700, color: '#F8FAFC' }}>Real-time System Performance</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span className="live-pulse-dot" style={{ width: '7px', height: '7px', borderRadius: '50%', background: '#34D399', boxShadow: '0 0 8px #34D399' }}></span>
                          <span style={{ fontSize: '0.68rem', color: '#00D4FF', fontWeight: 800, letterSpacing: '0.5px' }}>LIVE TELEMETRY</span>
                        </div>
                      </div>

                      {/* SVG Live Wave Graph */}
                      <svg viewBox="0 0 500 120" style={{ width: '100%', height: '90px', overflow: 'visible' }}>
                        <defs>
                          <linearGradient id="liveChartFill" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#00D4FF" stopOpacity="0.45" />
                            <stop offset="70%" stopColor="#6C63FF" stopOpacity="0.1" />
                            <stop offset="100%" stopColor="#000000" stopOpacity="0" />
                          </linearGradient>

                          <linearGradient id="liveLaserStroke" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#00D4FF" />
                            <stop offset="50%" stopColor="#A78BFA" />
                            <stop offset="100%" stopColor="#34D399" />
                          </linearGradient>
                        </defs>

                        {/* Shimmer Fill Area */}
                        <path
                          d="M0,90 Q80,20 160,60 T320,30 T500,10 L500,120 L0,120 Z"
                          fill="url(#liveChartFill)"
                        />

                        {/* Base Continuous Line */}
                        <path
                          d="M0,90 Q80,20 160,60 T320,30 T500,10"
                          fill="none"
                          stroke="rgba(0, 212, 255, 0.3)"
                          strokeWidth="2.5"
                        />

                        {/* RUNNING LIVE ANIMATED LASER WAVE LINE */}
                        <path
                          d="M0,90 Q80,20 160,60 T320,30 T500,10"
                          fill="none"
                          stroke="url(#liveLaserStroke)"
                          strokeWidth="3.5"
                          strokeDasharray="40 120"
                          className="running-live-wave"
                        />

                        {/* Live Radar Expanding Ripple Rings at Peak (320, 30) */}
                        <circle cx="320" cy="30" r="14" fill="none" stroke="#00D4FF" strokeWidth="1.5" className="live-radar-ripple" />
                        <circle cx="320" cy="30" r="8" fill="none" stroke="#34D399" strokeWidth="1.5" className="live-radar-ripple-delay" />
                        <circle cx="320" cy="30" r="5" fill="#00D4FF" style={{ filter: 'drop-shadow(0 0 6px #00D4FF)' }} />

                        {/* Floating Live Telemetry Tooltip Badge */}
                        <g transform="translate(330, 10)">
                          <rect x="0" y="0" width="105" height="24" rx="6" fill="rgba(6, 12, 30, 0.92)" stroke="rgba(52, 211, 153, 0.5)" strokeWidth="1" />
                          <circle cx="10" cy="12" r="3" fill="#34D399" />
                          <text x="18" y="16" fill="#FFFFFF" fontSize="10" fontWeight="bold" fontFamily="sans-serif">99.99% Uptime</text>
                        </g>
                      </svg>
                    </div>
                  </div>
                )}

                {/* AI Automation Robot Tab Content */}
                {activeTab === 'ai' && (
                  <div className="fade-in-tab">
                    {/* Robot Assistant Header Box */}
                    <div
                      style={{
                        background: 'rgba(0, 212, 255, 0.08)',
                        padding: '14px',
                        borderRadius: '14px',
                        border: '1px solid rgba(0, 212, 255, 0.25)',
                        marginBottom: '12px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '14px',
                      }}
                    >
                      <div
                        style={{
                          width: '46px',
                          height: '46px',
                          borderRadius: '12px',
                          overflow: 'hidden',
                          border: '2px solid #00D4FF',
                          boxShadow: '0 0 14px rgba(0, 212, 255, 0.4)',
                          flexShrink: 0,
                        }}
                      >
                        <img
                          src="/images/ai-automation-expert.png"
                          alt="AI Automation Robot"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      </div>
                      <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <span style={{ fontSize: '0.88rem', fontWeight: 800, color: '#FFF' }}>AI Automation Expert</span>
                          <span style={{ fontSize: '0.6rem', color: '#34D399', background: 'rgba(52, 211, 153, 0.15)', padding: '2px 6px', borderRadius: '4px', fontWeight: 700 }}>
                            ● Active Agent
                          </span>
                        </div>
                        <p style={{ fontSize: '0.74rem', color: '#CBD5E1', margin: '2px 0 0 0', lineHeight: 1.35 }}>
                          Autonomous AI agents execute complex enterprise tasks with sub-second decision latency.
                        </p>
                      </div>
                    </div>

                    {/* 3 Small Data Chips / Metrics */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '8px' }}>
                      <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '8px 10px', borderRadius: '10px', border: '1px solid rgba(255, 255, 255, 0.06)', textAlign: 'center' }}>
                        <span style={{ fontSize: '0.62rem', color: '#94A3B8', display: 'block' }}>Tasks Automated</span>
                        <span style={{ fontSize: '1rem', fontWeight: 800, color: '#FFFFFF' }}>14,200+</span>
                      </div>

                      <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '8px 10px', borderRadius: '10px', border: '1px solid rgba(255, 255, 255, 0.06)', textAlign: 'center' }}>
                        <span style={{ fontSize: '0.62rem', color: '#94A3B8', display: 'block' }}>Decision Latency</span>
                        <span style={{ fontSize: '1rem', fontWeight: 800, color: '#38BDF8' }}>&lt; 50ms</span>
                      </div>

                      <div style={{ background: 'rgba(255, 255, 255, 0.03)', padding: '8px 10px', borderRadius: '10px', border: '1px solid rgba(255, 255, 255, 0.06)', textAlign: 'center' }}>
                        <span style={{ fontSize: '0.62rem', color: '#94A3B8', display: 'block' }}>Model Precision</span>
                        <span style={{ fontSize: '1rem', fontWeight: 800, color: '#A78BFA' }}>99.98%</span>
                      </div>
                    </div>
                  </div>
                )}

                {/* Cloud Tab Content */}
                {activeTab === 'cloud' && (
                  <div className="fade-in-tab" style={{ padding: '8px' }}>
                    <div style={{ background: 'rgba(108, 99, 255, 0.08)', padding: '14px', borderRadius: '14px', border: '1px solid rgba(108, 99, 255, 0.25)', marginBottom: '12px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                        <i className="fas fa-cloud-upload-alt" style={{ color: '#A78BFA', fontSize: '1rem' }}></i>
                        <span style={{ fontSize: '0.9rem', fontWeight: 800, color: '#FFF' }}>Global Multi-Region Cloud</span>
                      </div>
                      <p style={{ fontSize: '0.78rem', color: '#CBD5E1', margin: 0, lineHeight: 1.45 }}>
                        Deployed across AWS & GCP edge locations delivering sub-50ms response times worldwide.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Running Animated Border Beam & Live Graph Wave CSS Styles */}
      <style>{`
        /* Hardware Acceleration Optimization for Running Border & Animations */
        .running-border-beam-card,
        .running-border-badge,
        .smooth-float-badge-top,
        .smooth-float-badge-bottom {
          transform: translateZ(0);
          will-change: transform;
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
        }

        .running-border-beam-card::before,
        .running-border-badge::before {
          will-change: transform;
          transform: translateZ(0);
          contain: paint layout;
        }

        .running-border-beam-inner,
        .running-border-badge-inner {
          backdrop-filter: blur(14px);
          -webkit-backdrop-filter: blur(14px);
        }

        /* Running Live Laser Wave Path Animation */
        .running-live-wave {
          animation: laserWaveRun 2.5s linear infinite;
          will-change: stroke-dashoffset;
        }

        @keyframes laserWaveRun {
          0% {
            stroke-dashoffset: 160;
          }
          100% {
            stroke-dashoffset: 0;
          }
        }

        /* Radar Expanding Ripple Animation */
        .live-radar-ripple {
          animation: radarPulse 2s cubic-bezier(0, 0.2, 0.8, 1) infinite;
          transform-origin: 320px 30px;
        }
        .live-radar-ripple-delay {
          animation: radarPulse 2s cubic-bezier(0, 0.2, 0.8, 1) infinite 0.7s;
          transform-origin: 320px 30px;
        }

        @keyframes radarPulse {
          0% {
            r: 4px;
            opacity: 1;
            stroke-width: 2px;
          }
          100% {
            r: 22px;
            opacity: 0;
            stroke-width: 0.5px;
          }
        }

        /* Pulse Dot Indicator */
        .live-pulse-dot {
          animation: liveDotPulse 1.5s ease-in-out infinite alternate;
        }
        @keyframes liveDotPulse {
          0% { transform: scale(1); opacity: 0.7; }
          100% { transform: scale(1.4); opacity: 1; }
        }

        /* Running Border Beam Outer Wrapper for Main Card */
        .running-border-beam-card {
          position: relative;
          border-radius: 28px;
          padding: 1.5px;
          background: rgba(108, 99, 255, 0.2);
          overflow: hidden;
          box-shadow: 0 30px 80px rgba(0, 0, 0, 0.7), 0 0 50px rgba(108, 99, 255, 0.25);
        }

        .running-border-beam-card::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: conic-gradient(
            from 0deg at 50% 50%,
            transparent 0deg,
            transparent 270deg,
            #00D4FF 310deg,
            #A78BFA 340deg,
            #00D4FF 360deg
          );
          animation: rotateBorderBeam 6s linear infinite;
        }

        .running-border-beam-inner {
          position: relative;
          z-index: 2;
          border-radius: 26.5px;
          background: rgba(11, 15, 36, 0.94);
        }

        /* Running Border Badge Wrapper */
        .running-border-badge {
          position: relative;
          border-radius: 16px;
          padding: 1.5px;
          background: rgba(0, 212, 255, 0.2);
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0, 212, 255, 0.3);
        }

        .running-border-badge::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: conic-gradient(
            from 0deg at 50% 50%,
            transparent 0deg,
            transparent 260deg,
            #00D4FF 300deg,
            #38BDF8 330deg,
            #00D4FF 360deg
          );
          animation: rotateBorderBeam 5s linear infinite;
        }

        .running-border-badge-inner {
          position: relative;
          z-index: 2;
          border-radius: 14.5px;
          background: rgba(15, 23, 42, 0.95);
        }

        @keyframes rotateBorderBeam {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes orbFloat1 {
          0%, 100% { transform: translate3d(0, 0, 0) scale(1); }
          50% { transform: translate3d(15px, -20px, 0) scale(1.08); }
        }
        @keyframes orbFloat2 {
          0%, 100% { transform: translate3d(0, 0, 0) scale(1); }
          50% { transform: translate3d(-20px, 15px, 0) scale(1.08); }
        }
        @keyframes badgeFloatTop {
          0%, 100% { transform: translate3d(0, 0, 0); }
          50% { transform: translate3d(0, -8px, 0); }
        }
        @keyframes badgeFloatBottom {
          0%, 100% { transform: translate3d(0, 0, 0); }
          50% { transform: translate3d(0, 8px, 0); }
        }
        @keyframes fadeInTab {
          from { opacity: 0; transform: translate3d(0, 8px, 0); }
          to { opacity: 1; transform: translate3d(0, 0, 0); }
        }

        .smooth-glow-orb-1 {
          animation: orbFloat1 14s ease-in-out infinite;
        }
        .smooth-glow-orb-2 {
          animation: orbFloat2 16s ease-in-out infinite;
        }
        .smooth-float-badge-top {
          animation: badgeFloatTop 6s ease-in-out infinite;
        }
        .smooth-float-badge-bottom {
          animation: badgeFloatBottom 7s ease-in-out infinite;
        }
        .fade-in-tab {
          animation: fadeInTab 0.3s ease-out forwards;
        }

        @media (max-width: 1024px) {
          .dashboard-3d-card {
            transform: none !important;
          }
          .smooth-float-badge-top {
            right: 0px !important;
            top: -16px !important;
          }
          .smooth-float-badge-bottom {
            left: 0px !important;
            bottom: -16px !important;
          }
        }
        @media (max-width: 640px) {
          .smooth-float-badge-top,
          .smooth-float-badge-bottom {
            display: none !important;
          }
          .dashboard-inner-metrics-grid {
            grid-template-columns: 1fr !important;
            gap: 8px !important;
          }
          .running-border-beam-inner {
            padding: 16px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Hero;
